export interface EmployeeRegion {
  id: number;
  name: string;
  displayOrder: number;
  inactive: boolean;
}

export const EmployeeRegionNotApplicable = 1;
